import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { actionManageMessage, actionShowLoading, actionDismissLoading, actionMessage } from "redux/shared/SharedSlice";
import { CotizacionesMapper, CotizacionesUnMapper } from "./CotizacionesMapper";
import {
  apiCallGetAllCotizaciones,
  apiCallGetCotizacion,
  apiCallCotizacionesSave,
  apiCallCotizacionesUpdate,
  apiCallCotizacionesDelete,
} from "../api/CotizacionesServices";
import { CONSTANTS_MESSAGE } from "config/constants/Message";

const oInitialState = {
  aCotizaciones: [],
  bStatus: false,
  oCotizacion: null,
};

export const actionCotizacionesGetAll = createAsyncThunk("cotizaciones/getAllCotizaciones", async(args, oThunk) => {
  try {
    oThunk.dispatch(actionShowLoading());
    const oSuccess = await apiCallGetAllCotizaciones();
    oThunk.dispatch(actionDismissLoading());
    return CotizacionesMapper(oSuccess.data);
  } catch (oError) {
    oThunk.dispatch(actionManageMessage(oError));
    oThunk(oError);
  }
});

export const actionCotizacionesGet = createAsyncThunk("cotizaciones/getCotizacion", async({ nMonId, sFecha }, oThunk) => {
  try {
    oThunk.dispatch(actionShowLoading());
    const oSuccess = await apiCallGetCotizacion(nMonId, sFecha);
    oThunk.dispatch(actionDismissLoading());
    return CotizacionesMapper(oSuccess.data);
  } catch (oError) {
    oThunk.dispatch(actionManageMessage(oError));
    oThunk(oError);
  }
});

export const actionCotizacionesDelete = createAsyncThunk("cotizaciones/deleteCotizaciones", async({ nMonId, sFecha }, oThunk) => {
  try {
    oThunk.dispatch(actionShowLoading());
    const oSuccess = await apiCallCotizacionesDelete(nMonId, sFecha);
    oThunk.dispatch(actionDismissLoading());
    oThunk.dispatch(
      actionMessage({
        message: oSuccess.message || "Cotización eliminada correctamente",
        type: CONSTANTS_MESSAGE.TYPE_SUCCESS,
      }),
    );
    oThunk.dispatch(actionCotizacionesGetAll());
  } catch (oError) {
    oThunk.dispatch(actionManageMessage(oError));
    oThunk(oError);
  }
});

export const actionCotizacionesSave = createAsyncThunk("cotizaciones/saveCotizacion", async(oCotizacion, oThunk) => {
  try {
    oThunk.dispatch(actionShowLoading());
    const oCotizacionMapped = CotizacionesUnMapper(oCotizacion);
    const oSuccess = await apiCallCotizacionesSave(oCotizacionMapped);
    oThunk.dispatch(actionDismissLoading());
    oThunk.dispatch(
      actionMessage({
        message: oSuccess.message || "Cotización generada correctamente",
        type: CONSTANTS_MESSAGE.TYPE_SUCCESS,
      }),
    );
    oThunk.dispatch(actionCotizacionesGetAll());
    return true;
  } catch (oError) {
    oThunk.dispatch(actionManageMessage(oError));
    oThunk(oError);
  }
});

export const actionCotizacionesUpdate = createAsyncThunk("cotizaciones/updateCotizaciones", async(oCotizacion, oThunk) => {
  try {
    oThunk.dispatch(actionShowLoading());
    const oCotizacionMapped = CotizacionesUnMapper(oCotizacion);
    const oSuccess = await apiCallCotizacionesUpdate(oCotizacionMapped);
    oThunk.dispatch(actionDismissLoading());
    oThunk.dispatch(
      actionMessage({
        message: oSuccess.message || "Cotización actualizada correctamente",
        type: CONSTANTS_MESSAGE.TYPE_SUCCESS,
      }),
    );
    oThunk.dispatch(actionCotizacionesGetAll());
    return true;
  } catch (oError) {
    oThunk.dispatch(actionManageMessage(oError));
    oThunk(oError);
  }
});

const CotizacionesSlice = createSlice({
  name: "CotizacionesSlice",
  initialState: oInitialState,
  reducers: {
    actionCotizacionesClean: oState => {
      oState.bStatus = false;
    },
  },
  extraReducers: builder => {
    builder.addCase(actionCotizacionesGetAll.fulfilled, (oState, oAction) => {
      oState.aCotizaciones = oAction.payload;
    });
    builder.addCase(actionCotizacionesGet.fulfilled, (oState, oAction) => {
      oState.oCotizacion = oAction.payload;
    });
    builder.addCase(actionCotizacionesSave.fulfilled, (oState, oAction) => {
      oState.bStatus = oAction.payload;
    });
    builder.addCase(actionCotizacionesUpdate.fulfilled, (oState, oAction) => {
      oState.bStatus = oAction.payload;
    });
  },
});

export const { actionCotizacionesClean } = CotizacionesSlice.actions;

export default CotizacionesSlice.reducer;
